import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import styles from 'modules/Auth/authwrapper.module.scss'
import { Container, PaymentLogo } from 'gu-ui-kit'
import GridSpinner from 'components/UI/GridSpinner'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { notificationShow } from 'modules/Notifications/actions'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'

const PaymentsReturnUrl = () => {
  const { type } = useParams()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const { user } = useSelector(({ app }) => app)

  useEffect(() => {
    dispatch(
      notificationShow({
        type: type === 'success' || type === 'result' ? 'success' : 'error',
        message: t('common::notifications.payment_result', { context: type }),
        delay: 5000,
      }),
    )

    if (!global.opener || typeof global.opener.getBack === 'undefined') {
      global.location.assign(pathGen(user ? ROUTES.FINANCE_WALLETS : ROUTES.SERVICES))
      return
    }

    global.opener.getBack()
    global.close()
  }, [])

  return (
    <Container className={styles['loader']}>
      <div className={styles['logo-container']}>
        {IS_APP_PRODUCT_GETUNIQ ? (
          <>
            <PaymentLogo name={'getuniq'} color={'black'} />
            <GridSpinner width={16} color={'black'} />
          </>
        ) : (
          <>
            <PaymentLogo
              width={'40'}
              name={'adsimple'}
              color={'black'}
              className={styles['loader-logo']}
            />
            <GridSpinner width={24} color={'Interface-GU-Primary'} />
          </>
        )}
      </div>
    </Container>
  )
}

export default PaymentsReturnUrl
